/**
 * Lists email attachments for an RMA action modal and allows removing them.
 */
import { observer } from "mobx-react-lite";
import { FormField } from "../../../../../../components/form-field/form-field";
import { ButtonIcon } from "../../../../../../components/inputs/button-icon/button-icon";
import IconDelete from "../../../../../../components/icons/icon-delete/icon-delete";
import './rma-email-attachments.scss';
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import type { IRmaActionEmailNotificationStore } from "../../../rma-types";

interface IProps {
    emailStore: IRmaActionEmailNotificationStore;
}

const RmaEmailAttachments: React.FC<IProps> = observer(({ emailStore }) => {
    return (
        <FormField label="Uploaded files">
            <div>
                {emailStore.emailAttachments.map((emailAttachment, index) => (
                    <div className="rma-email-attachment" key={index}>
                        <FontBody1 color={FONT_COLOR.PRIMARY3_50}>{emailAttachment.name}</FontBody1>
                        <ButtonIcon Component={IconDelete} color={'var(--color-accent-1)'} onClick={() => emailStore.removeEmailAttachment(emailAttachment)} />
                    </div>
                ))}
            </div>
        </FormField>
    );
});

export default RmaEmailAttachments;